module.exports = __webpack_public_path__ + "static/img/icon_cercanias.71acbd93.svg";